import {Component, Inject} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from "@angular/material/dialog";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { MatFormField, MatLabel, MatSelect, MatOption } from "@angular/material/select";
import { MatButton } from "@angular/material/button";

@Component({
    selector: "app-select-quarter-dialog",
    templateUrl: "./select-quarter-dialog.component.html",
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatFormField, MatLabel, MatSelect, MatOption, MatDialogActions, MatButton, MatDialogClose]
})
export class SelectQuarterDialogComponent {
  quarters: string[] = ["Q1", "Q2", "Q3", "Q4"];
  selectedQuarter: string;

  constructor(public dialogRef: MatDialogRef<SelectQuarterDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    const currentQuarter = Math.floor((new Date().getMonth() + 3) / 3);
    this.selectedQuarter = `Q${currentQuarter}`;
  }
}
